import React from "react";

const InfoBlue = ({ ...rest }) => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M13.9997 18.6667V14M13.9997 9.33337H14.0113M25.6663 14C25.6663 20.4434 20.443 25.6667 13.9997 25.6667C7.55635 25.6667 2.33301 20.4434 2.33301 14C2.33301 7.55672 7.55635 2.33337 13.9997 2.33337C20.443 2.33337 25.6663 7.55672 25.6663 14Z"
                stroke="#283A97"
                strokeWidth="2.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default InfoBlue;
